import { Transcoder } from '@img-arena/consoles-api-streaming'
import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'

import { ActionMenuDialogItem } from '../ActionMenuDialogItem/ActionMenuDialogItem'
import { useActionMenuContext } from '../context/ActionMenuContext'

interface ActionToggleTranscoderStatusItemProps {
  onClick: (row: Transcoder) => Promise<void> | void
}

export const ActionToggleTranscoderStatusItem = ({
  onClick
}: ActionToggleTranscoderStatusItemProps) => {
  const { row } = useActionMenuContext<Transcoder>()
  const isReserved = row.reserved

  return (
    <ActionMenuDialogItem
      onClick={onClick}
      successMessage={`Transcoder ${row.id} (${row.ip}) ${isReserved ? 'unreserved' : 'reserved'} successfully`}
      errorMessage={`Failed to ${isReserved ? 'unreserve' : 'reserve'} Transcoder ${row.id} (${row.ip})`}
      confirmationMessage={`Are you sure you want to ${isReserved ? 'unreserve' : 'reserve'} Transcoder ${row.id} (${row.ip})?`}
      label={isReserved ? 'Let go' : 'Reserve'}
      overrideText={isReserved ? 'Unreserve Transcoder' : 'Reserve Transcoder'}
      icon={isReserved ? <LockOpenIcon /> : <LockIcon />}
    />
  )
}
